module.exports = __webpack_public_path__ + "static/media/bl.45426dc9.webp";